// @ts-nocheck
import t from './editItem.types';

export const setActiveView = (view) => ({
  type: t.EDIT_ITEM_SET_ACTIVE_VIEW,
  payload: view,
});

export const setStages = (stages) => ({
  type: t.EDIT_ITEM_SET_STAGES,
  payload: stages,
});

export const addStage = (stage) => ({
  type: t.EDIT_ITEM_ADD_STAGE,
  payload: stage,
});

export const deleteStage = (stageId) => ({
  type: t.EDIT_ITEM_DELETE_STAGE,
  payload: stageId,
});

export const setStageFormData = (stageId, data) => ({
  type: t.EDIT_ITEM_SET_STAGE_FORM_DATA,
  payload: { stageId, data },
});

export const setFormData = (data) => ({
  type: t.EDIT_ITEM_SET_FORM_DATA,
  payload: data,
});

export const setHasVariants = (hasVariants) => ({
  type: t.EDIT_ITEM_SET_HAS_VARIANTS,
  payload: hasVariants,
});

export const setVariants = (variants) => ({
  type: t.EDIT_ITEM_SET_VARIANTS,
  payload: variants,
});

export const setSubtotal = (view, subtotal) => ({
  type: t.EDIT_ITEM_SET_SUBTOTAL,
  payload: { view, subtotal },
});

export const setVariantsTotal = (view, total) => ({
  type: t.EDIT_ITEM_SET_VARIANTS_TOTAL,
  payload: { view, total },
});

export const setChargesTotal = (view, total) => ({
  type: t.EDIT_ITEM_SET_CHARGES_TOTAL,
  payload: { view, total },
});

export const setDecorationsTotal = (view, total) => ({
  type: t.EDIT_ITEM_SET_DECORATIONS_TOTAL,
  payload: { view, total },
});

export const setCharges = (view, charges) => ({
  type: t.EDIT_ITEM_SET_CHARGES,
  payload: { view, charges },
});

export const setDecoration = (view, decoration) => ({
  type: t.EDIT_ITEM_SET_DECORATION,
  payload: { view, decoration },
});

export const setImages = (images) => ({
  type: t.EDIT_ITEM_SET_IMAGES,
  payload: images,
});

export const setVariantSchema = (schema) => ({
  type: t.EDIT_ITEM_SET_VARIANT_SCHEMA,
  payload: schema,
});

export const resetEditItem = () => ({
  type: t.EDIT_ITEM_RESET,
});
